import RequestManagerTS from "./RequestManager";
import declare from 'dojo/_base/declare';

//damit der RequestManagerTS auch im legacy AMD loader als more/RequestManager geladen werden kann (z.b. in _WidgetBaseSP.js)
const DojoRequestManager = declare('more/RequestManager', [RequestManagerTS], {
    // Any Dojo-specific overrides or mixins would go here if needed.
});

export default DojoRequestManager;
